import useSWR from 'swr';

import container from 'src/container';
import { Organization } from 'src/domain/organization';
import { useCurrentOrganizationId } from './useCurrentOrganizationId';

const {
    cradle: { munduClient },
} = container;

export const useCurrentOrganization = () => {
    const organizationId = useCurrentOrganizationId();
    const swrResponse = useSWR<Organization>(
        organizationId ? ['organization', organizationId] : null,
        (_key, id: string) => munduClient.getOrganization(id),
    );

    return {
        organizationId,
        organization: swrResponse.data,
        isLoading:
            Boolean(organizationId) && !swrResponse.data && !swrResponse.error,
        error: swrResponse.error,
    };
};
